export default __webpack_public_path__ + "static/media/mastercard.9fbe6441.svg";